import React from 'react';
import { Form } from 'react-bootstrap';
import ReactDragListView from 'react-drag-listview';

import Const from '../../util/Constants';
import { Position } from 'reactflow';

class FieldListPopup extends React.Component {
  constructor(props) {
    super(props);
    let list = [];
    const keys = Object.keys(props.fields);
    keys.forEach(field => {
      if (props.fields[field].visible === Const.True && field === Const.Address) {
        let key = Const.Address;
        let index = props.visibleFields.indexOf(key);
        list.push({
          key, label: props.fields[field].label_name,
          check: index !== -1, order: index
        });

        key = field + Const.Opt + Const.Street;
        index = props.visibleFields.indexOf(key);
        list.push({ key, label: Const.Tstreet, check: index !== -1, order: index });

        key = field + Const.Opt + Const.City;
        index = props.visibleFields.indexOf(key);
        list.push({ key, label: Const.Tcity, check: index !== -1, order: index });

        key = field + Const.Opt + Const.State;
        index = props.visibleFields.indexOf(key);
        list.push({ key, label: Const.Tstate, check: index !== -1, order: index });

        key = field + Const.Opt + Const.Country;
        index = props.visibleFields.indexOf(key);
        list.push({ key, label: Const.Tcountry, check: index !== -1, order: index });

        key = field + Const.Opt + Const.Pin;
        index = props.visibleFields.indexOf(key);
        list.push({ key, label: Const.Tpin, check: index !== -1, order: index });
      } else if (props.fields[field].visible === Const.True) {
        const index = props.visibleFields.indexOf(field);
        list.push({
          key: field, label: props.fields[field].label_name,
          check: index !== -1, order: index
        });
      }
    });
    list = list.sort((l, r) => {
      if (l.order !== -1 && r.order !== -1) return l.order > r.order ? 1 : -1;
      else if (l.order !== -1) return -1;
      else if (r.order !== -1) return 1;
      else return 0;
    });

    this.state = { list };
  }

  onDrag = (fromIndex, toIndex) => {
    let list = [...this.state.list];
    const item = list.splice(fromIndex, 1)[0];
    list.splice(toIndex, 0, item);
    list = list.map((field, i) => { field.order = field.order !== -1 ? i : -1; return field; });
    this.setState({ ...this.state, list });
  }

  onChange = index => {
    let list = [...this.state.list];
    if (!list[index].check) {
      const order = Math.max.apply(Math, list.map(field => { return field.order; }));
      list[index].order = order + 1;
      list[index].check = true;
    } else {
      list[index].order = -1;
      list[index].check = false;
    }

    list = list.sort((l, r) => {
      if (l.order !== -1 && r.order !== -1) return l.order > r.order ? 1 : -1;
      else if (l.order !== -1) return -1;
      else if (r.order !== -1) return 1;
      else return 0;
    });
    this.setState({ ...this.state, list });
  }

  onFieldSelection = () => {
    let list = [...this.state.list];
    list = list.filter(field => field.order !== -1);
    list = list.sort((l, r) => { return l.order > r.order ? 1 : -1; });
    const fields = list.map(field => field.key);
    this.props.onFieldSelection(fields);
  }

  render() {
    const uiList = this.state.list.map((field, i) =>
      <li key={`field_selection_${i}`}>
        <div className="lead-setting-list">
          <Form.Check onChange={() => this.onChange(i)} checked={field.check} />
          <span className="input-field">{field.label}</span>
        </div>
      </li>
    );

    return (
      <div className="popup-box">
        <div className="box">
          <div className="col-md-12 text-right">
            <button
              style={{ position: 'fixed' }}
              type="button" className="close" aria-label="Close" onClick={this.onFieldSelection}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="row">
            <div className="col-md-6 mt-5 filterul">
              <p><strong>Note:</strong> Kindly drag and drop column to order as per your requirement.</p>
              <ReactDragListView onDragEnd={this.onDrag} nodeSelector="li" handleSelector="div">
                <ol className="filterulol"> {uiList} </ol>
              </ReactDragListView>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default FieldListPopup;